import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import { baseUrlApi } from "../../proxy";
import CAxios from "../utils/CAxios";

export const toGetSurvey = createAsyncThunk<AxiosResponse<any, any>, any>(
  "survey/toGetSurvey",
  async (targeted) => {
    try {
      const response = await axios.post(`${baseUrlApi}survey`, {
        targeted: targeted,
      });
      return response?.data?.result;
    } catch (error) {
      throw error;
    }
  }
);
export const toAddSurvey = createAsyncThunk<AxiosResponse<any, any>, any>(
  "survey/toAddSurvey",
  async (survey) => {
    try {
      const response = await axios.post(
        `${baseUrlApi}survey/not_beneficiary/response`,
        survey
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
 //Add survey sponsors and Beneficiaries
export const toAddSurveyResponse = createAsyncThunk<AxiosResponse<any, any>, any>(
  "survey/toAddSurveyResponse",
  async (survey) => {
    try {
      const response = await CAxios.post(`survey/response`, survey);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
